<template>
  <div>
    <div class="flex bg-fff mb-4 border">
      <img
        :src="
          get_volbyid.profile
            ? $imageURL + '/' + get_volbyid.profile
            : require('@/assets/images/blank-profile.png')
        "
        :alt="get_volbyid.userId.firstname"
        class="w-1/4 object-cover"
      />
      <div class="profile-main lg:p-4 md:p-4 p-2 w-1/2">
        <h1 class="fsize18px sm-fsize16 capitalize line-height-30px">
          <b
            >{{ get_volbyid.userId.firstname }}
            {{ get_volbyid.userId.lastname }}</b
          >
        </h1>
        <!-- <p class="fsize14">{{ get_volbyid.location }}</p>
        <h3 class="fsize14 font-semibold lg:mt-2 md:mt-2">
          +91 {{ get_volbyid.userId.mobile }}
        </h3>
        <h3 class="fsize14">{{ get_volbyid.experties }}</h3> -->
      </div>
      <!-- <div
        class="border-prof flex flex-col justify-evenly lg:p-4 md:p-4 p-2 w-1/4"
      >
        <template v-if="$route.query.service">
          <h1
            class="fsize20px sm-fsize14 font-semibold flex items-center justify-center w-full line-through"
            v-if="
              getUserByUserId.currentMembership &&
              serviceDiscount.hasOwnProperty(
                getUserByUserId.currentMembership.name
              ) &&
              serviceDiscount[getUserByUserId.currentMembership.name] > 0
            "
          >
            Rs. {{ get_volbyid.price }} /hr
          </h1>
          <h1
            class="fsize18px sm-fsize14 font-semibold flex items-center justify-center w-full"
          >
            Rs.
            {{
              getUserByUserId.currentMembership &&
              serviceDiscount.hasOwnProperty(
                getUserByUserId.currentMembership.name
              )
                ? get_volbyid.price -
                  (get_volbyid.price *
                    Number(
                      serviceDiscount[getUserByUserId.currentMembership.name]
                    )) /
                    100
                : get_volbyid.price
            }}
            /hr
          </h1>
        </template>
        <template v-else>
          <h1
            class="fsize18px sm-fsize14 font-semibold flex items-center justify-center w-full"
          >
            Rs. {{ get_volbyid.price }} /hr
          </h1>
        </template>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("respitecare", {
      get_volbyid: "get_volbyid",
    }),
    ...mapState("respitecare", {
      serviceDiscount: "serviceDiscount",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  mounted() {
    // console.log(this.serviceDiscount);
    // console.log(this.getUserByUserId);
    // console.log(this.get_volbyid);
  },
};
</script>

<style>
.fsize30px {
  font-size: 30px;
}
.fsize20px {
  font-size: 20px;
}
.border-prof {
  border-left: 1px solid #edeeee;
}
.w-40 {
  width: 40%;
}
.w-60 {
  width: 60%;
}
.h-11rem {
  height: 11.5rem;
}
.bg-fff {
  background: #fff;
}
</style>
